// What to tell someone when the microphone will not open, in plain words.
// The browser's own messages ("Requested device not found") explain nothing.

// TikTok, Instagram and Facebook open links in their own little browsers,
// which mostly will not share the microphone with a page.
export const inAppBrowser = (): boolean =>
  /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly|Bytedance|BytedanceWebview|Snapchat|Line\//i.test(navigator.userAgent);

export function micWords(name: string | undefined): string {
  if (inAppBrowser()) {
    return 'Songbird listens through your microphone, and the app you tapped this link in will not share it. '
      + 'Open this page in your phone\'s own browser (the three dots or the share button, then Open in browser) and it will hear you.';
  }
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'Songbird listens through your microphone, and the browser said no. '
        + 'Allow the microphone (the little icon by the address), then try again.';
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'Songbird can\'t find a microphone on this device. '
        + 'Give it a song to listen to instead and watch the shape of the sound, or plug a microphone in and try again.';
    case 'NotReadableError':
    case 'AbortError':
      return 'Something else is using your microphone right now. Close it, then try again.';
    case 'NotSupportedError':
    case 'TypeError':
      return 'This browser won\'t share a microphone with Songbird. Safari, Chrome or Firefox will.';
    default:
      return 'Songbird couldn\'t open your microphone. Try again, or try another browser.';
  }
}
